import React from "react";
import RegisterComp from "../../components/Frontend/RegisterComp";
import HomePageLayout from "../../layouts/HomepageLayout";

const Register = () => {
  return (
    <HomePageLayout>
      <div className="auth register">
        <div className=" inner">
          <div className="info">
            <div className="info-text">
              <h1>REGISTRATION</h1>
              <hr />
              <p>
                Please take a moment to fill-in and check thoroughly the
                registration form, we want to thank you in advance for your time
                and interest.
              </p>
            </div>
          </div>
          <div className="form">
            <RegisterComp />
          </div>
        </div>
      </div>
    </HomePageLayout>
  );
};

export default Register;
